<template>
  <div>
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />

    <vs-table
      ref="table"
      multiple
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="enums"
      class="card-table"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW -->
          <vs-button
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            color="primary"
            type="border"
            @click="addNewData"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> {{ $t('button.add_new') }}
          </vs-button>

          <!-- Delete -->
          <vs-button
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            color="primary"
            type="border"
            @click="openConfirmMultiple"
          >
            <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" /> {{ $t('button.delete') }}
          </vs-button>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{ enums.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : enums.length }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>{{ 5 | persian_digits }}</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>{{ 10 | persian_digits }}</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>{{ 50 | persian_digits }}</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>{{ 100 | persian_digits }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="key">{{ $t('system.common.key') }}</vs-th>
        <vs-th sort-key="value">{{ $t('system.common.value') }}</vs-th>
        <vs-th>{{ $t('system.common.action') }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody v-if="data.length">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="enum-name font-medium truncate">{{ tr.key }}</p>
            </vs-td>

            <vs-td>
              <p class="enum-category">{{ tr.value.join(', ') }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="openConfirm(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './EnumSidebar.vue'

export default {
  components: {
    DataViewSidebar
  },
  data() {
    return {
      enums: [],

      selected: [],
      itemsPerPage: 4,
      isMounted: false,

      deleteMultipleDataFlag: true,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {
        item: {}
      }
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.enums.length
    }
  },
  methods: {
    addNewData() {
      this.sidebarData.item = {}
      this.toggleDataSidebar(true)
    },
    openConfirm(data) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: `Are you sure to delete ${data.key} .`,
        accept: () => this.deleteData(data.id)
      })
    },
    openConfirmMultiple() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure to delete all the selected enums?',
        accept: this.deleteMultipleData
      })
    },
    deleteData(id) {
      this.$store.dispatch('enum/removeEnum', id).then(response => {
        this.$notifySuccess(`Enum: ${response.key}`, 'Object Deleted')
        this.enums = this.enums.filter(enums => enums.id !== id)
      })
    },
    deleteMultipleData() {
      if (this.selected.length > 0) {
        for (let i = 0; i < this.selected.length; i++) {
          this.$store
            .dispatch('enum/removeEnum', this.selected[i].id)
            // eslint-disable-next-line no-unused-vars
            .then(response => {
              this.enums = this.enums.filter(enums => enums.id !== this.selected[i].id)
            })
            .catch(() => {
              this.deleteMultipleDataFlag = false
            })
        }
        if (this.deleteMultipleDataFlag) {
          this.$notifySuccess('All enums removed successfully', 'Deleted all')
        } else {
          this.$notifyError({ message: 'Somethings goes wrong, look at the console.' })
        }
        this.deleteMultipleDataFlag = true
      } else {
        this.$notifyWarning('Nothing to delete', 'Information')
      }
    },
    editData(data) {
      this.sidebarData.item = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    }
  },
  mounted() {
    this.isMounted = true
    this.$store.dispatch('enum/fetchEnums').then(() => {
      this.enums = this.$store.state.enum.enums
    })
  }
}
</script>
